import script from "./ProgressRing.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressRing.vue?vue&type=script&setup=true&lang=ts"

import "./ProgressRing.vue?vue&type=style&index=0&id=4f5615ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f5615ba"]])

export default __exports__